import MarkdownIt from "markdown-it";

interface RenderMarkdownOptions {
  openLinksInNewTab?: boolean;
  withoutImages?: boolean;
  webLinksOnly?: boolean;
  isLinkHidden?: (href: string) => boolean;
}

const md = new MarkdownIt({ html: false, linkify: true, breaks: true });

const isWebLink = (href: string) => !/^[a-z][a-z0-9+.-]*:/i.test(href) || /^(https?|mailto):/i.test(href);

md.renderer.rules["link_open"] = (tokens, idx, options, env, self) => {
  const token = tokens[idx];
  const href = String(token?.attrGet("href") ?? "");
  const isLinkHidden: unknown = env?.["isLinkHidden"];
  const isHidden = typeof isLinkHidden === "function" && isLinkHidden(href) === true;
  if (token && (isHidden || (env?.["webLinksOnly"] === true && !isWebLink(href)))) {
    const closeIndex = tokens.findIndex((candidate, index) => index > idx && candidate.type === "link_close");
    const linkClose = tokens[closeIndex];
    if (linkClose) {
      linkClose.meta = { dropped: true };
      if (isHidden) {
        tokens.slice(idx + 1, closeIndex).forEach((labelToken) => {
          labelToken.type = "text";
          labelToken.content = "";
        });
      }
    }
    return "";
  }
  if (token && env?.["openLinksInNewTab"] === true) {
    token.attrSet("target", "_blank");
    token.attrSet("rel", "noopener noreferrer");
  }
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules["link_close"] = (tokens, idx, options, _env, self) =>
  tokens[idx]?.meta?.["dropped"] === true ? "" : self.renderToken(tokens, idx, options);

const renderImage = md.renderer.rules["image"];
md.renderer.rules["image"] = (tokens, idx, options, env, self) => {
  if (env?.["withoutImages"] === true) {
    return md.utils.escapeHtml(self.renderInlineAsText(tokens[idx]?.children ?? [], options, env));
  }
  return renderImage ? renderImage(tokens, idx, options, env, self) : self.renderToken(tokens, idx, options);
};

export const renderMarkdown = (
  content: string,
  { openLinksInNewTab, withoutImages, webLinksOnly, isLinkHidden }: RenderMarkdownOptions
): string => md.render(content, { openLinksInNewTab, withoutImages, webLinksOnly, isLinkHidden });
